
import { Component, Prop, Vue } from 'vue-property-decorator';

/**
 * XmlUploadInput - Presentational XML upload component
 *
 * Props:
 *   - modelValue: File | null (v-model data)
 *   - fileRule: Function (validation rule)
 *   - uploadTitle: String (label text)
 *   - tooltipText: String (help tooltip)
 *   - ariaLabel: String (accessibility)
 *
 * Emits:
 *   - update:modelValue: when file is selected
 *   - validation-error: when validation fails (string message or null to clear)
 */
@Component
export default class XmlUploadInput extends Vue {
  // Data
  isDragging: boolean = false;

  // Props - Vue 2 uyumlu: value prop kullan
  @Prop({ default: null })
  readonly value!: File | null;

  @Prop({ type: Function, default: null })
  readonly fileRule!: ((file: File | null) => boolean | string) | null;

  @Prop({
    type: String,
    default: 'XML Dosyasını Yükle*'
  })
  readonly uploadTitle!: string;

  @Prop({
    type: String,
    default: 'Takip öncesi tahsilat içeren dosyalarda, alacak kalemlerinin takibe esas tutar hesaplamasında oluşan belirsizlik nedeniyle bu takiplerin E-İcraPro üzerinden açılması durdurulmuştur.'
  })
  readonly tooltipText!: string;

  @Prop({
    type: String,
    default: 'XML dosyası yükleme alanı'
  })
  readonly ariaLabel!: string;

  onFileChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    const files = input.files;
    if (!files?.length) return;

    this.handleSelectedFile(files[0]);
    input.value = '';
  }

  handleContainerClick(): void {
    const fileInput = this.$refs.fileInput as HTMLInputElement;
    if (fileInput) {
      fileInput.click();
    }
  }

  handleFileDrop(event: DragEvent): void {
    const files = event.dataTransfer?.files;
    this.isDragging = false;
    if (!files?.length) return;

    this.handleSelectedFile(files[0]);
  }

  private handleSelectedFile(file: File | null): void {
    if (!file) {
      this.emitValidationError('XML dosyası seçilmelidir');
      return;
    }

    const validationResult = this.fileRule ? this.fileRule(file) : true;

    if (validationResult === true) {
      this.$emit('validation-error', null);
      this.$emit('input', file);
      return;
    }

    if (typeof validationResult === 'string') {
      this.emitValidationError(validationResult);
      return;
    }

    this.emitValidationError('XML dosyası doğrulanamadı');
  }

  private emitValidationError(message: string): void {
    this.$emit('validation-error', message);
  }

  handleRemoveFile(): void {
    this.$emit('input', null);
    this.$emit('validation-error', null);
  }
}
